// export const liveUrl = "http://localhost:5000/api";
export const liveUrl = "https://backend.covernow.in/api";
